import React, { useState, useEffect } from "react";
import { Doughnut } from 'react-chartjs-2';
import { Tooltip, Legend } from 'chart.js';
import {api} from '../../../api'
import Cookies from "js-cookie";

const CircleChart = () => {
  // Dummy data for present and absent employees
  const presentPercentage = 50;
  const absentPercentage = 10;
  const lateCommer = 10;
  const ontimeCommer = 12;


  const [count, setCount] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log("hello");
    const fetchData = async () => {
      console.log("hello");
      try {
        console.log("hello");
         const company_id = Cookies.get('company_id');
        const emp_id = Cookies.get('emp_id');
        const response = await api.get(`hrdashboard.php?company_id=${company_id}&emp_id=${emp_id}`);
        setCount(response.data);
        console.log(count[4].present + "hello");
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);



  // Prepare data for chart
  const totalEmployees = count[0]?.empcount ?? 0;
  const present = count[3]?.present ?? 0;
  const late = count[2]?.latecount ?? 0;
  const ontime = count[1]?.ontimecount ?? 0;
  let absent = totalEmployees - present;
  if (absent < 0) absent = 0;

  const values = [present, absent, late, ontime];
  const labels = ['Present', 'Absent', 'Late', 'On-time'];
  const baseColors = ['#E5E5E5', '#E5E5E5', '#E5E5E5', '#E5C09A']; // Only last (On-time) is colored, rest are gray

  // Find the index of the highest value
  const maxValue = Math.max(...values);
  const maxIdx = values.findIndex(v => v === maxValue);

  // Set highlight color for the highest, light gray for others
  const highlightColors = baseColors.map((color, idx) =>
    idx === maxIdx ? '#E5C09A' : '#E5E5E5'
  );

  const data = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: highlightColors,
        borderWidth: 0,
      },
    ],
  };

  const options = {
    cutout: '78%', // Make the donut thicker
    plugins: {
      legend: {
        display: true,
        position: 'top',
        align: 'center',
        labels: {
          boxWidth: 18,
          boxHeight: 18,
          padding: 20, // More space between legend items
          font: {
            size: 16,
            weight: 'bold',
          },
          color: '#222',
          usePointStyle: false,
        },
        // Custom legend margin
        maxHeight: 30,
      },
      tooltip: { enabled: true },
    },
    layout: {
      padding: {
        top: 40, // Add space between legend and chart
        bottom: 0,
        left: 0,
        right: 0,
      },
    },
    maintainAspectRatio: false,
  };

  return (
    <div style={{ position: 'relative', width: 320, height: 320, margin: '0 auto' }}>
      <Doughnut data={data} options={options} />
      <div style={{
        position: 'absolute',
        top: 50,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
      }}>
        <div style={{ fontSize: 18, color: '#888', fontWeight: 500, marginBottom: 2 }}>{labels[maxIdx]}</div>
        <div style={{ fontSize: 48, fontWeight: 700 }}>{values[maxIdx]}</div>
      </div>
    </div>
  );
};

export default CircleChart;
